/** 購入フロー 共通レイアウト: ヘッダー＋パンくず＋タイトル＋5ステップ (P2) */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../purchase.scss';

const STEPS = ['プランの選択', '契約情報の入力', 'お申し込み内容の確認', '完了'];

export const PurchaseLayout: React.FC<{
  step: number; // 1..5
  sectionTitle?: string;
  sectionSub?: string;
  children: React.ReactNode;
}> = ({ step, sectionTitle, sectionSub, children }) => {
  const nav = useNavigate();
  return (
    <div className="pf">
      <div className="pf-page">
        {/* ヘッダー(外部リンク系はプレースホルダ=非機能) */}
        <div className="pf-hd">
          <img className="pf-logo-img" src="/mock/terrace.png" alt="GB照らす"
            style={{ height: 28, width: 'auto', display: 'block' }} />
          <nav className="pf-nav">
            <a>サービス・料金について</a>
            <a>ニュースリリース</a>
            <a>よくあるご質問</a>
          </nav>
          <div className="pf-hd-r">
            <span className="pf-hd-link">お問い合わせ ›</span>
            <span className="pf-hd-link">資料ダウンロード ›</span>
            <button className="pf-btn-o" onClick={() => nav('/login')}>ログイン ›</button>
            <button className="pf-btn-p" onClick={() => nav('/purchase')}>お申し込み ›</button>
          </div>
        </div>

        <div className="pf-crumb">TOP ＞ サービスのお申し込み</div>
        <h1 className="pf-title">サービスのお申し込み</h1>

        {/* ステッパー */}
        <div className="pf-steps">
          {STEPS.map((t, i) => {
            const n = i + 1;
            const cls = n === step ? 'active' : n < step ? 'done' : '';
            return (
              <React.Fragment key={t}>
                {i > 0 && <div className={`pf-line ${n <= step ? 'done' : ''}`} />}
                <div className={`pf-step ${cls}`}>
                  <div className="n">{n}</div>
                  <div className="t">{t}</div>
                </div>
              </React.Fragment>
            );
          })}
        </div>

        {sectionTitle && (
          <div className="pf-sec">
            <h2>{step}. {sectionTitle}</h2>
            {sectionSub && <span className="sub">{sectionSub}</span>}
          </div>
        )}

        <div className="pf-body">{children}</div>
      </div>
    </div>
  );
};

export default PurchaseLayout;
